import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'reports',
        loadChildren: './theme/reports/reports.module#ReportsModule'
      },
      {
        path: 'question-management',
        loadChildren: './theme/question-management/question-management.module#QuestionManagementModule'
      },
      {
        path: 'site-management',
        loadChildren: './theme/site-management/site-management.module#SiteManagementModule'
      },
      {
        path: 'dashboard',
        loadChildren: './theme/dashboard/dashboard.module#DashboardModule'
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        loadChildren: './theme/auth/login/login.module#LoginModule'
      },
      {
        path: 'reset-password',
        loadChildren: './theme/auth/reset-password/reset-password.module#ResetPasswordModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
